export default [
	/**
	 * 首页Tab关怀 -> 关注家属页
 	*/
	// {
	// 	path: "/care/careFamilyMembers",
	// 	component: resolve => require.ensure([], () => resolve(require("@/views/careFamilyMembers/care-family-members")), "careFamilyMembers"),
	// 	meta: {
	// 		title: "关注家属"
	// 	}
	// },
	{
		path: "/care/complaintCommendationList",
		component: resolve => require.ensure([], () => resolve(require("@/views/complaintCommendation/complaint-commendation-list")), "complaintCommendationList"),
		meta: {
			title: "投诉表扬"
		}
	},
	{
		path: "/care/complaintCommendation",
		component: resolve => require.ensure([], () => resolve(require("@/views/complaintCommendation/complaint-commendation")), "complaintCommendation"),
		meta: {
			title: "投诉表扬"
		}
	},
	{
		path: "/care/complaintCommendationDetail",
		component: resolve => require.ensure([], () => resolve(require("@/views/complaintCommendation/complaint-commendation-detail")), "complaintCommendationDetail"),
		meta: {
			title: "投诉表扬"
		}
	}
]



// WEBPACK FOOTER //
// ./src/router/careFamilyMembers.js